export default __webpack_public_path__ + "static/media/linen@3x.2f304411.png";